import React, {Component} from 'react';
import Rules from '../../utils/validation_rules';
import classnames from 'classnames';

export default class Input extends Component {
    static defaultProps = {
        label: '',
        placeholder: null,
        id: 'input',
        validators: [],
        errorMessage: '',
        value: '',
        required: false,
        className: '',
        onChange: () => {},
        onBlur: () => {},
        onFocus: () => {}
    }

    state = {
        isValid: true,
        is_success: false,
        error_message: null,
        show_errors: false,
        forced_error: false,
        value: ''
    }

    componentDidMount = () => {
        if (this.props.value) {
            this.setState({
                value: this.props.value
            });
        }
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps.value && this.props.value === this.state.value) {
            this.setState({
                value: newProps.value
            });
        }
    }

    validate = () => {
        let isValid = true;
        let message = this.props.errorMessage || '';
        let rules = this.props.validators;
        if (this.props.required) {
            rules = [
                Rules.isRequired,
                ...this.props.validators
            ];
        }

        if (!this.state.value && !this.props.required) {
            this.setState({
                isValid: isValid,
                error_message: message
            });
            return isValid;
        }

        for (let {func, msg} of rules) {
            let test = func.call(this);
            isValid = isValid && test;
            message = msg;
            if (!test) break; // break on the first failed test.
        }

        this.setState({
            isValid: isValid,
            error_message: message
        });

        return isValid;
    }

    getValue = () => {
        return this.state.value;
    }

    focus = () => {
        return this._input.focus();
    }

    forceInvalidate = (message) => {
        this.setState({
            isValid: false,
            is_success: false,
            error_message: message || null,
            forced_error: true
        });
    }

    handleFocus = () => {
        this.setState({
            show_errors: true
        });
        this.props.onFocus();
    }

    handleChange = () => {
        this.setState({
            value: this._input.value
        }, () => {
            if (!this.state.isValid) {
                this.validate();
            }
            this.props.onChange(this.state.value);
        });
    }

    handleBlur = () => {
        if (this.validate() && !this.state.forced_error) {
            this.setState({
                is_success: true
            });
        }
        this.setState({
            show_errors: false
        });
        this.props.onBlur();
    }

    render = () => {
        let errors = null;
        let label = null;
        let labelCss = [
            this.props.required ? 'required' : null,
            this.props.hideLabel ? 'hidden' : null,
            this.props.flex ? 'flex' : null
        ];

        if (this.props.label) {
            label = <label htmlFor={this.props.id} className={labelCss.join(' ')}>{this.props.label}</label>;
        }

        if (!this.state.isValid) {
            errors = (<div className="errors-list" style={{opacity: this.state.show_errors ? 1 : 0}}>
                <span>{this.state.error_message}</span>
            </div>);
        }

        return (
            <div className={this.props.className}>
                {label}
                <div className="input-box">
                    <input
                        className={classnames({
                            'input-collapse': this.props.collapse,
                            'error': !this.state.isValid,
                            'success': this.state.isValid && this.state.is_success
                        })}
                        ref={ref => (this._input = ref)}
                        value={this.state.value}
                        type={this.props.type}
                        name={this.props.id}
                        id={this.props.id}
                        required={this.props.required}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        onChange={this.handleChange}
                        placeholder={this.props.placeholder}
                        disabled={this.props.disabled}
                    />
                    {errors}
                    {this.props.children}
                </div>
            </div>
        );
    }
}
